const STORAGE_KEY_PREFIX = "lastScrollTarget_";
const HIGHLIGHT_CLASSES: string[] = [];
const HIGHLIGHT_DURATION_MS = 1200;

export function saveScrollTarget(elementId: string, pageKey: string) {
  sessionStorage.setItem(`${STORAGE_KEY_PREFIX}${pageKey}`, elementId);
}

export function restoreScrollTarget(pageKey: string) {
  const elementId = sessionStorage.getItem(`${STORAGE_KEY_PREFIX}${pageKey}`);
  if (!elementId) return;

  sessionStorage.removeItem(`${STORAGE_KEY_PREFIX}${pageKey}`);

  const el = document.getElementById(elementId);
  if (!el) return;

  el.scrollIntoView({ behavior: "smooth", block: "center" });
  el.classList.add(...HIGHLIGHT_CLASSES);
  setTimeout(() => el.classList.remove(...HIGHLIGHT_CLASSES), HIGHLIGHT_DURATION_MS);
}
